export default __webpack_public_path__ + "assets/images/favicon.52c95e78.png";